import { render, staticRenderFns } from "./FormLicensePeriod.vue?vue&type=template&id=01464b84&scoped=true&"
import script from "./FormLicensePeriod.vue?vue&type=script&lang=js&"
export * from "./FormLicensePeriod.vue?vue&type=script&lang=js&"
import style0 from "./FormLicensePeriod.vue?vue&type=style&index=0&id=01464b84&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01464b84",
  null
  
)

export default component.exports